import * as React from "react";
import {routeDefinition} from "utils";
import {RouteType} from "enums/routeType";

import Layout from "components/common/layout";

export default class Error extends React.Component<{}, {}> {
    render() {
        return (
            <Layout title="Error">

                <div className="error-page-inner">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner">
                                    <h1 className="title theme-gradient">Ups!</h1>
                                    <h3 className="sub-title">Unexpected error occurred</h3>
                                    <span>We are truly sorry but something didn't really gone well.</span>
                                    <div className="error-button">
                                        <a className="rn-button-style--2 btn-solid" href={routeDefinition(RouteType.home)}>
                                            Back To Homepage
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Layout>
        );
    }
}
